import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
import CdnVideo from 'components/util/CdnVideo'
import React from 'react'
import VideoPlayer from '../common/video-player'

import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

interface Props {
  backgroundColor: string
  videoSrc: any
  imageSrc: any
  imageSrcAlt: string
  videoShouldLoop: boolean
  playbackSettings: 'string'
  roundedCorners: boolean
  width: number
  headingText: string
  headingTextColor: string
  subHeading: string
  textOne: string
  textTwo: string
  headingClass: HeadingClass
  headingType: HeadingType
}

const VideoText = ({
  backgroundColor,
  videoSrc,
  imageSrc,
  imageSrcAlt,
  videoShouldLoop,
  playbackSettings,
  roundedCorners,
  width,
  headingText,
  headingTextColor,
  subHeading,
  textOne,
  textTwo,
  headingClass,
  headingType
}: Props) => {
  const renderText = (styles: string, text: string) => {
    return <div className={styles} dangerouslySetInnerHTML={{ __html: text }} />
  }
  return (
    <>
      <div className={`w-full mx-auto lg:mt-8`} style={{ backgroundColor: backgroundColor || '#ffffff' }}>
        <div className="max-w-7xl flex flex-col lg:flex-row mx-auto pt-8 lg:pt-0">
          <div className="w-full lg:w-3/5">
            {' '}
            <div
              className={`mx-auto h-full w-full p-5 sm:p-8 ${roundedCorners ? 'video-rounded-corner' : ''}`}
              style={{ backgroundColor }}
            >
              {videoSrc ? (
                <CdnVideo
                  videoSrc={videoSrc}
                  imageSrc={imageSrc}
                  videoLoop={videoShouldLoop}
                  playbackSettings={playbackSettings}
                  width={width}
                  account={false}
                />
              ) : (
                <CdnImage className="" url={imageSrc} alt={imageSrcAlt} />
              )}{' '}
            </div>{' '}
          </div>
          <div className="w-full lg:w-2/5 flex flex-col justify-center items-center px-8 lg:text-left lg:pl-0 lg:pr-6 my-8">
            {' '}
            {headingText && (
              <CustomHeading
                classList="text-center lg:text-left text-4xl w-full"
                headingClass={headingClass}
                headingType={headingType}
                color={headingTextColor}
              >
                {headingText}
              </CustomHeading>
            )}
            {subHeading &&
              renderText(
                `enable-list-styles mt-4 text-center text-base font-medium font-sans w-full justify-center`,
                subHeading
              )}
            {textOne &&
              renderText(
                `enable-list-styles mt-4 text-center text-base font-medium font-sans w-full justify-center`,
                textOne
              )}
            {textTwo &&
              renderText(
                `enable-list-styles mt-4 text-center text-base font-medium font-sans w-full justify-center`,
                textTwo
              )}
          </div>
        </div>
      </div>
    </>
  )
}

export default VideoText

Builder.registerComponent(VideoText, {
  name: 'VideoText',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'videoSrc',
      type: 'file',
      defaultValue: null,
      allowedFileTypes: ['mp4']
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageSrcAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'playbackSettings',
      type: 'string',
      enum: ['Muted with auto play off', 'Muted with auto play on', 'Sound on with auto play off'],
      defaultValue: 'Muted with auto play off'
    },
    {
      name: 'videoShouldLoop',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'roundedCorners',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'width',
      type: 'number'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'Javascript for Beginners'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'subHeading',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textOne',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textTwo',
      type: 'richText',
      defaultValue: ''
    }
  ]
})
